// Logica pura de los campos que se envian al cargar un reporte.
// Separada de Admin.tsx para poder testearla: la decision de pedir/enviar `month`
// y `alcance` depende de dos listas de tipos y es facil que se contradigan.

export type Alcance = "historia" | "mes";

// Tipos que NO requieren seleccionar mes (el periodo sale del archivo).
export const TIPOS_SIN_MES: ReadonlyArray<string> = [
  "comparativo_diario_ventas",
  "comercial_diario_ventas",
  "oper_tiempos_salon",
  "oper_ocupabilidad_mesas",
  "oper_productos_mesero",
  "oper_rotacion_mesas",
  "margen_producto",
];

// Tipos que traen VARIOS periodos en el mismo archivo y permiten acotar la carga.
export const TIPOS_CON_ALCANCE: ReadonlyArray<string> = [
  "financiero",
  "food_cost",
  "comparativo_diario_ventas",
  "oper_tiempos_salon",
  "ventas_mensuales_producto",
];

export interface CamposUpload {
  /** Se muestra el input Mes y se valida que no este vacio. */
  requiereMes: boolean;
  /** Se muestra el selector de alcance. */
  alcanceActivo: boolean;
  /** El usuario eligio cargar solo un mes. */
  modoMes: boolean;
  /** Mostrar la pista "el mes se detecta del archivo". */
  mesDesdeArchivo: boolean;
  /** Se envia el campo `month` en el FormData. */
  enviaMonth: boolean;
  /** Se envia el campo `alcance` en el FormData. */
  enviaAlcance: boolean;
}

export function calcularCampos(tipo: string, alcance: Alcance): CamposUpload {
  const alcanceActivo = TIPOS_CON_ALCANCE.includes(tipo);
  const modoMes = alcanceActivo && alcance === "mes";
  const mesDesdeArchivo = TIPOS_SIN_MES.includes(tipo) && !modoMes;
  // `requiereMes` NO puede derivarse solo de TIPOS_SIN_MES: hay tipos que estan
  // en las DOS listas (comparativo diario, tiempos de salon). Para esos, "el mes
  // sale del archivo" vale con alcance='historia', pero si el usuario elige
  // "solo el mes indicado" el mes ES obligatorio. La version anterior daba false
  // siempre para ellos: el input Mes no se renderizaba y el front mandaba
  // alcance=mes sin month -> 400 del backend.
  const requiereMes =
    modoMes || (!TIPOS_SIN_MES.includes(tipo) && !alcanceActivo);

  return {
    requiereMes,
    alcanceActivo,
    modoMes,
    mesDesdeArchivo,
    // Invariante: si se manda alcance='mes' se manda month.
    enviaMonth: requiereMes,
    enviaAlcance: alcanceActivo,
  };
}
